import { Dropdown } from 'antd';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

import UserAvatar from '../ticket-drawer/UserAvatar';
import {
  getProjectById,
  removeMemberFromProject,
  removeMemberFromWorkspace,
  updateProjectUsers,
  updateWorkspaceUsers
} from '../../../../actions';

const WorkspaceMemberRow = ({ member, workspaceId, isProject = false, projectId, isMember = false }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [role, setRole] = useState(member?.role);
  const me = useSelector(state => state.userReducer.user);

  useEffect(() => {
    setRole(member?.role);
  }, [member, projectId])

  if (!member) return null;
  const { fullName, email, _id, avi } = member;

  const items = [
    {
      key: 'guest',
      label: intl.formatMessage({ id: 'GUEST', defaultMessage: 'Guest' }),
      onClick: () => updateRole('guest', _id),
    },
    {
      key: 'member',
      label: (
        <div className={role == 'member' ? 'text-blue-600' : ''}>
          {intl.formatMessage({ id: 'MEMBER', defaultMessage: 'Member' })}
        </div>
      ),
      onClick: () => updateRole('member', _id),
    },
    {
      key: 'admin',
      label: (
        <div className={role == 'admin' ? 'text-blue-600' : ''}>
          {intl.formatMessage({ id: 'ADMIN', defaultMessage: 'Admin' })}
        </div>
      ),
      onClick: () => updateRole('admin', _id),
    },
  ];

  if (role != 'owner') {
    items.push({
      key: 'remove',
      label: (
        <div className='text-red-400'>
          {intl.formatMessage({
            id: isProject ? 'REMOVE_FROM_PROJECT' : 'REMOVE_FROM_WORKSPACE',
            defaultMessage: isProject ? 'Remove from project' : 'Remove from workspace'
          })}
        </div>
      ),
      onClick: async () => {
        if (isProject) {
          await dispatch(removeMemberFromProject({
            projectId: projectId,
            members: [
              _id
            ]
          }, () => {
            dispatch(getProjectById(projectId))
          }));
        } else {
          await dispatch(removeMemberFromWorkspace({
            workspaceId: workspaceId,
            members: [
              _id
            ]
          }))
        }
      }
    });
  }

  const updateRole = async (role, userId) => {
    let newRole = {
      "users": [
        {
          "userId": userId,
          "role": role
        }
      ]
    }

    if (!isProject) {
      newRole.workspaceId = workspaceId
      dispatch(updateWorkspaceUsers(newRole, () => setRole(role)));
    } else {
      newRole.projectId = projectId;
      dispatch(updateProjectUsers(newRole, () => setRole(role)));
    }
  }

  const isDisabled = role === 'owner' || isMember;

  return (
    <div
      key={_id}
      className="flex items-center justify-between px-4 py-2.5 transition-colors cursor-pointer"
      style={{ borderBottom: '1px solid rgba(99,102,241,0.07)' }}
      onMouseEnter={e => e.currentTarget.style.background = 'rgba(99,102,241,0.04)'}
      onMouseLeave={e => e.currentTarget.style.background = ''}
    >
      <div className="flex items-center gap-3">
        <UserAvatar
          alt="User"
          fullName={fullName}
          userId={_id}
          src={avi}
          styles={{ objectFit: 'cover', width: 32, height: 32, borderRadius: 8, flexShrink: 0 }}
        />
        <div>
          <div className="text-sm font-semibold" style={{ color: 'rgba(15,15,25,0.85)' }}>
            {fullName}
            {me?._id == member?._id && <span className="ml-1 text-xs font-medium px-1.5 py-0.5 rounded-md" style={{ background: 'rgba(99,102,241,0.08)', color: 'rgba(99,102,241,0.7)' }}>You</span>}
          </div>
          <div className="text-xs" style={{ color: 'rgba(15,15,25,0.4)' }}>{email}</div>
        </div>
      </div>
      <Dropdown trigger={['click']} menu={{ items }} placement="bottom" arrow disabled={isDisabled}>
        <div className="flex items-center gap-1 px-2 py-1 rounded-lg transition-colors capitalize text-xs font-medium"
          style={{ color: 'rgba(15,15,25,0.55)', cursor: isDisabled ? 'default' : 'pointer' }}
          onMouseEnter={e => { if (!isDisabled) e.currentTarget.style.background = 'rgba(99,102,241,0.08)'; }}
          onMouseLeave={e => e.currentTarget.style.background = ''}
        >
          {role && role === 'collaborator'
            ? intl.formatMessage({ id: 'MEMBER', defaultMessage: 'Member' })
            : intl.formatMessage({ id: role ? role?.toUpperCase() : 'Member', defaultMessage: role || 'Member' })}
          {!isDisabled && <img src="/images/icons/black-arrow-down.svg" alt="arrow" className="w-2 h-2 ml-0.5 opacity-40" />}
        </div>
      </Dropdown>
    </div>
  );
};

export default WorkspaceMemberRow;
